// eslint-disable-next-line import/no-cycle
import { createRoutesMap } from '../app/route-map';

export const routingMap = createRoutesMap('');
